import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import React, { useState, useEffect} from 'react';
import './Profile.css'
import { useNavigate } from 'react-router-dom';
import { fetchProducer } from '../../services/api';
import FaqNav from "../../components/FAQ/FaqNav";
import Toast from "../../components/Toast/Toast";
import {useSearchParams } from 'react-router-dom';
import { downloadFile } from '../../services/GenericAPI';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const ProducerProfile= () => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [logoDetails, setLogoDetails]=useState({name:'', downloadPath:''});
  const [logoSource, setLogoSource]=useState('');
  const [StoredDocuments, setStoredDocuments]=useState('');
  const [formData, setFormData] = useState({
    producer: {
        producerType: ''
    },
    companyName: '',
    companyRegNo: '',
    title: '',
    name: '',
    email:"",
    website: '',
    socialMediaLinks:"",
    productionType: '',
    vatRegistrationNumber:"",
    isTaxClearanceCertificate: false,
    isApprovedByAuth: false,
    isTermAndCondition: false,
    taxClearanceCertPin:"",
    isBBBEE:false,
    companyContactNumber:"",
    businessAddress:"",
    companyEmail:"",
    declarationOfInfo:"",
    isApproved:true,
    isActive: false,
    languages: [],
    channels: [],
    genres: [],
    productionTypes: [],
    formats: [],

    
});
const fetchProducerData = async () => {
  try {
    const data = await fetchProducer();

    if (!data || !data.content || !data.content.producer) {
      console.error("Invalid data structure received from API:", data);
      return; 
    }
    const documents = data?.content?.documents;
    setStoredDocuments(documents);

     const getDocumentDetails = (documentFor) => {
       const document = documents.find(file => file.documentFor === documentFor);
       return document ? { name: document.documentName.trim(), downloadPath: document.documentPath.trim() } : {};
     };
     setLogoDetails(getDocumentDetails('PLOGO'));
    const producer = data.content.producer;
    const languages = data.content.languages || [];
   const socialMediaArray = producer.socialMediaLinks
   ? producer.socialMediaLinks.split(',').map(link => link.trim()): [];

    setFormData((prevFormData) => ({
      ...prevFormData,
      producerId: producer.producerId || "",
      producerType: producer.producerType || "",
      companyName: producer.companyName || "", 
      companyRegNo: producer.companyRegNo || "",
      title: producer.title || "",
      name: producer.name || "",
      email: producer.email || "",
      website: producer.website || "",
      productionType: producer.productionType || "",
      vatRegistrationNumber: producer.vatRegistrationNumber || "",
      isTaxClearanceCertificate: producer.isTaxClearanceCertificate || false,
      taxClearanceCertExpiryDate: producer.taxClearanceCertExpiryDate || "",
      taxClearanceCertPin: producer.taxClearanceCertPin || "",
      isBBBEE: producer.isBBBEE || false,
      companyContactNumber: producer.companyContactNumber || "",
      businessAddress: producer.businessAddress || "",
      companyEmail: producer.companyEmail || "",
      isVendorRegistered: producer.isVendorRegistered || false,
      producer: producer.producer || '', 
      languages: data.content.languages || []  ,   
      genres: data.content.genres || [] ,
      formats: data.content.formats || [],
      channels: data.content.channels || [],
      socialMediaLinks: socialMediaArray,
      provinceId: producer.provinceId || null, 
      provinceName: producer.provinceName || "", 
      countryId: producer.countryId || null, 
      countryName: producer.countryName || "", 
       }));

  } catch (error) {
      console.error('Error fetching producer data:', error);
  }
}
useEffect(() => {
  fetchProducerData();
}, [languages]);

  const handleEdit = () => {
    navigate('/edit-producer')
  };
  
  useEffect(() => {
    if (searchParams.get('updatedSuccessfully') === 'true') {
      setShowSuccessToast(true);
      navigate({ search: '' });
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (showSuccessToast) {
      const timeoutId = setTimeout(() => {
        setShowSuccessToast(false);
      }, 4000);
      return () => clearTimeout(timeoutId);
    }
  }, [showSuccessToast]);


const handleToastClose = () => {
    setShowSuccessToast(false);
};

  const NavLinkData= {FirstNavbar:Globals.PRODUCER.DASHBOARD,SecondNavbar:Globals.INTERNAL.INDIVIDUALPRODUCERPROFILE,Title:Globals.INTERNAL.INDIVIDUALPRODUCERPROFILE}

const getLogoSource = async () => {
    try {
      const isForProducer = true;
      const response = await downloadFile(logoDetails.downloadPath, isForProducer);
      if (response?.data) {
        const blob = new Blob([response.data],{ type: response.headers['Content-Type'] }); 
        const fileUrl = URL.createObjectURL(blob);
        setLogoSource(fileUrl);
        setTimeout(() => URL.revokeObjectURL(fileUrl), 5000);
      } else {
        console.error("Error: No file data available for download.");
      }
    } catch (error) {
      console.error("Error in downloading the file:", error);
    }
  };

  useEffect(()=>{
    if(logoDetails.downloadPath){
      getLogoSource();
    }
  },[logoDetails.downloadPath])

  return (
    <div className="Background-Page">
     <Header />
     <div className='main-head'>
     <div className='nav-element'>
     <FaqNav props={NavLinkData}/>
     <div className="info-item-edit">
    <div className="edit-container back" onClick={handleEdit}>
      <img className="edit-icon" src={Globals.IMG.EDIT} alt="edit"  />
      <span className="edit-text">{Globals.HALF_PAGE_BRIEF_DETAILS.EDIT_BUTTON_TEXT}</span>
    </div></div>
  </div></div>
  <div className='profile-container'>
    <div className="main-profile">
    <div className="profile-page-wrapper">
      <div className='profile-pic-container'>
        <img src={logoSource || Globals.IMG.PROFILE_BIG} alt="Profile" className="profile-photo" />
      </div>
    
    <div className="profile-page-details"> 
    <span className="profile-page-company">{Globals.TABLE_HEADERS.PRODUCER}</span>
    <span className="profile-page-name">{formData.title && formData.title.trim() !== "" ? formData.title.trim().replace(/([^.])$/, '$1.') + " " + formData.name : formData.name}
</span>  
             <span className="profile-page-email">{formData.email}</span>
              </div> </div>
              <div className="seperator"></div>
              <div className='main-container'>
  <ul>
    <li>
    <h5 class="custom-margin">{Globals.INTERNAL.PRODUCERINFO}</h5>
   
    <div className="info-item">
  <h6 className='custom-font'>{Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE}</h6>
  {formData.languages.length > 0 ? (
    <div>
      {formData.languages.reduce((rows, language, index) => {
        if (index % 2 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(language);
        return rows;
      }, []).map((row, rowIndex) => (
        <div key={rowIndex}>
          {row.map((language, languageIndex) => (
            <span key={language.languageId}>
              {language.languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {formData.languages.indexOf(language) < formData.languages.length - 1 ? ", " : " "}
            </span>
          ))}
          <br />
        </div>
      ))}
    </div>
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>

      <div className="info-item">
      <h6 className="custom-font">{Globals.UNSOLICITED_PROPOSAL_HALF.GENRE}</h6>
      {formData.genres && formData.genres.length > 0 ? (
        <div>
          {formData.genres.reduce((rows, genre, index) => {
            if (index % 2 === 0) {
              rows.push([]);
            }
            rows[rows.length - 1].push(genre);
            return rows;
          }, []).map((row, rowIndex) => (
            <div key={rowIndex}>
              {row.map((genre, genreIndex) => (
                <span key={genre.genreId}>
                  {genre.genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
                  {formData.genres.indexOf(genre) < formData.genres.length - 1 ? ", " : " "}
                </span>
              ))}
              <br />
            </div>
          ))}
        </div>
      ) : (
        <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      )}
    </div>
    </li>
    <li>
    <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.CHANNELS}</h6>
  {formData.channels.length > 0 ? (
    <div>
      {formData.channels.reduce((rows, channel, index) => {
        if (index % 2 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(channel);
        return rows;
      }, []).map((row, rowIndex) => (
        <div key={rowIndex}>
          {row.map((channel, channelIndex) => (
            <span key={channel.channelId}>
              {channel.channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {formData.channels.indexOf(channel) < formData.channels.length - 1 ? ", " : " "}
            </span>
          ))}
          <br />
        </div>
      ))}
    </div>
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
     <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.WEBSITE}</h6>
  {formData.website ? (
    formData.website.split(",").map((website, index, array) => {
      const trimmedWebsite = website.trim();
      const websiteVariableName = Globals.WEBSITE_LINK;
      const firstLineCount = 2;
      return (
        <div key={index} className="website-link">
          <a
            //href={trimmedWebsite}
            href={trimmedWebsite.startsWith('http://') || trimmedWebsite.startsWith('https://') ? trimmedWebsite : `http://${trimmedWebsite}`}
            alt={websiteVariableName}
            target="_blank"
            rel="noopener noreferrer"
            className="link-value"
          >
            {websiteVariableName}
          </a>
          {index < firstLineCount - 1 && index < array.length - 1 && (
            <span className="separator">, </span>
          )}
          {index === firstLineCount - 1 && <br />}
        </div>
      );
    })
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
<div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.SOCIAL_MEDIA}</h6>
  {Array.isArray(formData.socialMediaLinks) && formData.socialMediaLinks.length > 0 && formData.socialMediaLinks.some(link => link.trim() !== "") ? (
    formData.socialMediaLinks
      .filter(link => link.trim() !== "") 
      .map((website, index) => {
      const websiteLabel = `${Globals.SIGNUP.SOCIAL_MEDIA} ${index + 1}`; 
      return (
        <div key={index} className="website-link">
          <a
            // href={website}
            href={website.startsWith('http://') || website.startsWith('https://') ? website : `http://${website}`}
            alt={websiteLabel} 
            target="_blank"
            rel="noopener noreferrer"
            className="link-value"
          >
            {websiteLabel} 
          </a>
          {index < formData.socialMediaLinks.length - 1 && (
            <span className="separator">, </span> 
          )}
        </div>
      );
    })
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
    </li>
  </ul>
  <div className="seperator"></div><div className="contact-info">
  <h5 className="custom-margin">{Globals.SIGNUP.CONTACT_INFO_LABEL}</h5>
  <ul>
    <li>
      <div className="info-item">
      <h6 className='custom-font'>{Globals.SIGNUP.PHONE_NUMBER}</h6>
        <span className='custom-data'>{formData.companyContactNumber || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>

      <div className="info-item">
      <h6 className='custom-font'>{Globals.SIGNUP.EMAIL}</h6>
        <span className='custom-data'>{formData.email || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>

      <div className="info-item">
      <h6 className='custom-font'>{Globals.SIGNUP.PHYSICAL_ADDRESS}</h6>
        <span className='custom-font-address'>{formData.businessAddress || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
      
<div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COUNTRY}</h6>
        <span className='custom-data'>{formData.countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA} </span>
      </div>
      
      <div className="info-item">
        <h6 className='custom-font' >{Globals.SIGNUP.PROVIENCE}</h6>
        <span className='custom-data'>{formData.provinceName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
    </li>

  </ul>
  
</div></div>
      
    </div></div>
    <Footer />
    <div>
            {showSuccessToast && (
                <Toast
                    status = "info"
                    onClose={handleToastClose}
                    title={Globals.PROFILE_UPDATED_SUCCESS}
                />
            )}
        </div>
    </div>
    
  );
}

export default ProducerProfile;